import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ApiConfig } from '@sp-core/api-config';
import { Observable } from 'rxjs';

export enum DictionaryType {
  CALCULATION = 'calculation',
  PRESCRIPTION = 'prescription',
  CONSULTATION = 'consultation',
}

@Injectable({
  providedIn: 'root',
})
export class HttpDictionariesService {
  constructor(private readonly http: HttpClient) {}

  public getCalculationDictionaries(patientGenderId: string): Observable<ICalcDictionariesApi> {
    return this.getDictionaries(DictionaryType.CALCULATION, patientGenderId);
  }

  public getPrescriptionDictionaries(patientGenderId: string): Observable<ISiteNoteDictionariesApi> {
    return this.getDictionaries(DictionaryType.PRESCRIPTION, patientGenderId);
  }

  public getConsultationDictionaries(patientGenderId: string): Observable<any> {
    return this.getDictionaries(DictionaryType.CONSULTATION, patientGenderId);
  }

  private getDictionaries<T>(type: DictionaryType, genderId: string): Observable<T> {
    const params = new HttpParams().set('genderId', genderId);
    const endpoint = this.getEndpointByType(type);

    return this.http.get<T>(endpoint, { params });
  }

  private getEndpointByType(type: DictionaryType): string {
    switch (type) {
      case DictionaryType.CALCULATION:
        return ApiConfig.calculationDictionaryPath;
      case DictionaryType.PRESCRIPTION:
        return ApiConfig.prescriptionDictionaryPath;
      case DictionaryType.CONSULTATION:
        return ApiConfig.consultationDictionaryPath;
      default:
        throw new Error(`Unknown dictionary type: ${type}`);
    }
  }
}
